module.exports = __webpack_public_path__ + "img/u6.4e37cbe2.png";